import Chart from 'chart.js'
import $ from 'jquery'

export default function ChartDefault(name = '', type = 'line', data = [], labels = [], title = '', xLabel = '', yLabel = '') {
    const chart = new Chart($(name), {
        type,
        data: {
            labels,
            datasets: [{
                label: title,
                data,
                fill: true,
                borderColor: '#2980b9',
                backgroundColor: '#74b9ff'
            }]
        },
        options: {
            responsive: true,
            title: {
                display: true,
            },
            tooltips: {
                mode: 'point',
                intersect: false,
            },
            hover: {
                mode: 'nearest',
                intersect: true
            },
            scales: {
                xAxes: [{
                    display: true,
                    scaleLabel: {
                        display: true,
                        labelString: xLabel
                    }
                }],
                yAxes: [{
                    display: true,
                    scaleLabel: {
                        display: true,
                        labelString: yLabel
                    },
                    ticks: {
                        beginAtZero: true
                    }
                }]
            }
        }
    })
    
}



// WEBPACK FOOTER //
// ./src/components/parts/Charts/index.js